<template>
  <li class="timeline-section__event">
    <span
      ref="dot"
      class="timeline-section__progress-dot"
      :class="{
        [$class('active')]: active
      }"
    />
    <h3
      class="text-heading-m timeline-section__event-heading"
      v-text="event.heading"
    />

    <div class="timeline-section__event-content">
      <div class="timeline-section__event-image">
        <responsive-image
          :image="event.image"
          min-max="300-300"
          sizes="300px"
          :padding="false"
        />
      </div>

      <div
        class="timeline-section__event-blurb"
        :class="[`timeline-section__event-blurb--${event.blurb_position}`]"
        v-html="event.blurb"
      />
    </div>
  </li>
</template>

<script>

/**
 * Vue: Timeline event (timeline-event)
 * -----------------------------------------------------------------------------
 * An event block in the timeline array
 *
 */

import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'TimelineEvent',

  components: {
    ResponsiveImage,
  },

  props: {
    event: {
      type: Object,
      default: () => ({
        heading: '',
        image: false,
        blurb: '',
        blurb_position: 'top',
      }),
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
